import React, { createContext, useState, useEffect, Fragment } from "react";
import immutable from "object-path-immutable";
import { auth } from "./Firebase";
import { useAuth, getUser } from "./User";

const AppContext = createContext();

// eslint-disable-next-line react/prop-types
const AppContextProvider = ({ children }) => {
  const [AppState, updateAppState] = useState({
    loading: true,
    authenticated: false,
    user: null
  });

  const { user: userAuth, loading: authLoading } = useAuth(auth);

  // User Auth Effect
  useEffect(() => {
    if (!authLoading && userAuth) {
      getUser(userAuth.uid).then(user => {
        updateAppState({
          loading: false,
          authenticated: user.role === "driver" ? false : true,
          user: user.role === "driver" ? null : user
        });
      });
    }

    if (!authLoading && !userAuth) {
      updateAppState({
        loading: false,
        authenticated: false,
        user: null
      });
    }
  }, [userAuth, authLoading]);

  return (
    <AppContext.Provider
      value={{
        state: AppState,
        updateState: updateAppState
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export { AppContext, AppContextProvider };
